<template>
  <form @submit.prevent="onSearch">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseInput
            v-model="filters.email"
            :placeholder="$t('placeholder.email')"
            :label="false"
            type="text">
        </BaseInput>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="emailTypeDropdown && emailTypeDropdown.length">
          <SelectVue
              v-model="filters.type"
              :options="emailTypeDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.type')"/>
        </div>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div v-if="emailStatusDropdown && emailStatusDropdown.length">
          <SelectVue
              v-model="filters.status"
              :options="emailStatusDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.status')"/>
        </div>
      </div>
      <div class="col-lg-2 col-sm-12 col-12">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import BaseInput from '@/components/base/BaseInput.vue';
import SelectVue from '@/components/SelectVue.vue';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {computed, defineEmits, defineProps, onMounted, ref, toRefs} from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const emailTypeDropdown = ref([]);
const emailStatusDropdown = ref([]);

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['search']);

// Use toRefs to maintain reactivity
const {filters} = toRefs(props);

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

async function getEmailEnumDropdowns() {
  emailStatusDropdown.value = getEnums.value?.emailStatus || [];
  emailTypeDropdown.value = getEnums.value?.emailTypes || [];
}

onMounted(async () => {
  await getEmailEnumDropdowns();
});

</script>

<style scoped>
</style>
